import React from "react";
import {
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Phone,
  Mail,
  MapPin,
  Clock,
  AlertCircle,
  ArrowRight
} from "lucide-react";
import "../styles/TopBar.css";

const TopBar = () => {
  return (
    <div className="rift-topbar-wrapper">
      <div className="container rift-topbar-container">
        
        {/* LEFT: SOCIAL ECOSYSTEM */}
        <div className="rift-social-strip">
          <a href="/" className="rift-social-link"><Twitter size={14} /></a>
          <a href="/" className="rift-social-link"><Facebook size={14} /></a>
          <a href="https://www.instagram.com/riftnakuruins?igsh=MTFib3prYWVxYnB0aw==" className="rift-social-link"><Instagram size={14} /></a>
          <a href="/" className="rift-social-link"><Linkedin size={14} /></a>
        </div>

        {/* CENTER: THE TRUST BAR (Glassmorphism) */}
        <div className="rift-trust-bar desktop-only">
          <div className="rift-trust-item">
            <Clock size={13} />
            <span>Mon - Fri: 08:00am - 05:00pm</span>
          </div>
          <span className="rift-dot"></span>
          <div className="rift-trust-item">
            <Clock size={13} />
            <span>Sat: 09:00am - 12:00pm</span>
          </div>
                    <span className="rift-dot"></span>
          <a href="tel:+254721498898" className="rift-trust-item clickable">
            <Phone size={13} />
            <span>+254 721 498898</span>
          </a>
          <span className="rift-dot"></span>
          <a href="mailto:insure@riftnakuru.com" className="rift-trust-item clickable">
            <Mail size={13} />
            <span>insure@riftnakuru.com</span>
          </a>
        </div>

        {/* RIGHT: GLOBAL ACTIONS */}
        <div className="rift-action-strip">
          <a href="/" className="rift-location-tag desktop-only">
            <MapPin size={13} />
            <span>Nakuru</span>
          </a>
          
          <a href="/claims" className="rift-emergency-btn">
            <div className="btn-content">
              <AlertCircle size={14} />
              <span>Report a Claim</span>
            </div>
            <ArrowRight size={14} className="btn-arrow" />
          </a>
        </div>

      </div>
    </div>
  );
};

export default TopBar;